import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  filterUsers,
  staff,
  councilMembers,
  cmStaffers,
} from '../../utils/helper';
import styles from '../../styles/UserSelect.module.scss';


const clean = str =>
  (str ?? '')
    .toString()
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '');

const toOption = item => {
  return (typeof item === 'string'
    ? { id: item, label: item }
    : {
        id: item.id ?? item.label ?? item.value,
        label:
          item.label ??
          item.committee_name ??
          item.name ??
          item.division_name ??
          '',
      });
}


const UserSelect = ({
  search,
  focused = false,
  handleClick,
  sponsor = '',
  typeOfUsers = '',
  options = [],
  users,
  userProfile,
}) => {

  let pool, sourceTag;

  if (options.length) {
    pool      = options.map(toOption);
    sourceTag = 'custom-options';
  } else {
    const sponsorStr = typeof sponsor === 'string' ? sponsor : String(sponsor ?? '');
    const spUser     = users.find(u => u.full_name === sponsorStr);

    switch (typeOfUsers) {
      case 'staff':
        pool      = staff(users).map(u => ({ id: u.id, label: u.full_name }));
        sourceTag = 'staff';
        break;
      case 'council members':
        pool      = councilMembers(users).map(u => ({ id: u.id, label: u.full_name }));
        sourceTag = 'council-members';
        break;
      case 'cm_staff':
        pool      = spUser ? cmStaffers(users, spUser, userProfile)
                              .map(u => ({ id: u.id, label: u.full_name })) : [];
        sourceTag = 'cm-staff';
        break;
      default:
        pool      = filterUsers(users).map(u => ({ id: u.id, label: u.full_name }));
        sourceTag = 'filtered-users';
    }
  }

  const query   = clean(search);
  const visible = query
    ? pool.filter(o => clean(o.label).includes(query))
    : pool.slice();

  visible.sort((a, b) => a.label.localeCompare(b.label));


  if (!focused)                 return null;
  if (!visible.length && query) return (
    <ul className={styles.UserSelect}>
      <li style={{ color: '#DD442F' }}>— No&nbsp;Matches —</li>
    </ul>
  );

  return (
    <ul className={styles.UserSelect}>
      {visible.map(opt => (
        <li
          key={opt.id}
          onMouseDown={e => {
            e.preventDefault();
            handleClick(e);
          }}
        >
          {opt.label}
        </li>
      ))}
    </ul>
  );
};


const mapStateToProps = state => ({
  users:       state.userReducer.userList,
  userProfile: state.userReducer.userProfile,
});


UserSelect.propTypes = {
  search:      PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  focused:     PropTypes.bool,
  sponsor:     PropTypes.any,
  typeOfUsers: PropTypes.string,
  options:     PropTypes.array,
};

export default connect(mapStateToProps)(UserSelect);
